// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Google = Caml_module.init_mod([
      "proto/third_party/google_rpc/gen/google_rpc_code.ml",
      227,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "Code"
              ]]
          },
          "Rpc"
        ]]
    });

const Rpc = Caml_module.init_mod([
      "proto/third_party/google_rpc/gen/google_rpc_code.ml",
      425,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "Code"
        ]]
    });

const Code = Caml_module.init_mod([
      "proto/third_party/google_rpc/gen/google_rpc_code.ml",
      611,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".google.rpc.Code";
}

function to_int(param) {
  switch (param) {
    case /* OK */0 :
        return 0;
    case /* CANCELLED */1 :
        return 1;
    case /* UNKNOWN */2 :
        return 2;
    case /* INVALID_ARGUMENT */3 :
        return 3;
    case /* DEADLINE_EXCEEDED */4 :
        return 4;
    case /* NOT_FOUND */5 :
        return 5;
    case /* ALREADY_EXISTS */6 :
        return 6;
    case /* PERMISSION_DENIED */7 :
        return 7;
    case /* UNAUTHENTICATED */8 :
        return 16;
    case /* RESOURCE_EXHAUSTED */9 :
        return 8;
    case /* FAILED_PRECONDITION */10 :
        return 9;
    case /* ABORTED */11 :
        return 10;
    case /* OUT_OF_RANGE */12 :
        return 11;
    case /* UNIMPLEMENTED */13 :
        return 12;
    case /* INTERNAL */14 :
        return 13;
    case /* UNAVAILABLE */15 :
        return 14;
    case /* DATA_LOSS */16 :
        return 15;
    
  }
}

function from_int_exn(n) {
  switch (n) {
    case 0 :
        return /* OK */0;
    case 1 :
        return /* CANCELLED */1;
    case 2 :
        return /* UNKNOWN */2;
    case 3 :
        return /* INVALID_ARGUMENT */3;
    case 4 :
        return /* DEADLINE_EXCEEDED */4;
    case 5 :
        return /* NOT_FOUND */5;
    case 6 :
        return /* ALREADY_EXISTS */6;
    case 7 :
        return /* PERMISSION_DENIED */7;
    case 8 :
        return /* RESOURCE_EXHAUSTED */9;
    case 9 :
        return /* FAILED_PRECONDITION */10;
    case 10 :
        return /* ABORTED */11;
    case 11 :
        return /* OUT_OF_RANGE */12;
    case 12 :
        return /* UNIMPLEMENTED */13;
    case 13 :
        return /* INTERNAL */14;
    case 14 :
        return /* UNAVAILABLE */15;
    case 15 :
        return /* DATA_LOSS */16;
    case 16 :
        return /* UNAUTHENTICATED */8;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* OK */0 :
        return "OK";
    case /* CANCELLED */1 :
        return "CANCELLED";
    case /* UNKNOWN */2 :
        return "UNKNOWN";
    case /* INVALID_ARGUMENT */3 :
        return "INVALID_ARGUMENT";
    case /* DEADLINE_EXCEEDED */4 :
        return "DEADLINE_EXCEEDED";
    case /* NOT_FOUND */5 :
        return "NOT_FOUND";
    case /* ALREADY_EXISTS */6 :
        return "ALREADY_EXISTS";
    case /* PERMISSION_DENIED */7 :
        return "PERMISSION_DENIED";
    case /* UNAUTHENTICATED */8 :
        return "UNAUTHENTICATED";
    case /* RESOURCE_EXHAUSTED */9 :
        return "RESOURCE_EXHAUSTED";
    case /* FAILED_PRECONDITION */10 :
        return "FAILED_PRECONDITION";
    case /* ABORTED */11 :
        return "ABORTED";
    case /* OUT_OF_RANGE */12 :
        return "OUT_OF_RANGE";
    case /* UNIMPLEMENTED */13 :
        return "UNIMPLEMENTED";
    case /* INTERNAL */14 :
        return "INTERNAL";
    case /* UNAVAILABLE */15 :
        return "UNAVAILABLE";
    case /* DATA_LOSS */16 :
        return "DATA_LOSS";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "ABORTED" :
        return /* ABORTED */11;
    case "ALREADY_EXISTS" :
        return /* ALREADY_EXISTS */6;
    case "CANCELLED" :
        return /* CANCELLED */1;
    case "DATA_LOSS" :
        return /* DATA_LOSS */16;
    case "DEADLINE_EXCEEDED" :
        return /* DEADLINE_EXCEEDED */4;
    case "FAILED_PRECONDITION" :
        return /* FAILED_PRECONDITION */10;
    case "INTERNAL" :
        return /* INTERNAL */14;
    case "INVALID_ARGUMENT" :
        return /* INVALID_ARGUMENT */3;
    case "NOT_FOUND" :
        return /* NOT_FOUND */5;
    case "OK" :
        return /* OK */0;
    case "OUT_OF_RANGE" :
        return /* OUT_OF_RANGE */12;
    case "PERMISSION_DENIED" :
        return /* PERMISSION_DENIED */7;
    case "RESOURCE_EXHAUSTED" :
        return /* RESOURCE_EXHAUSTED */9;
    case "UNAUTHENTICATED" :
        return /* UNAUTHENTICATED */8;
    case "UNAVAILABLE" :
        return /* UNAVAILABLE */15;
    case "UNIMPLEMENTED" :
        return /* UNIMPLEMENTED */13;
    case "UNKNOWN" :
        return /* UNKNOWN */2;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, Code, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "Code"
        ]]
    }, Rpc, {
      Code: Code
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "Code"
              ]]
          },
          "Rpc"
        ]]
    }, Google, {
      Rpc: Rpc
    });

export {
  Imported$pmodules ,
  Google ,
}
/* Google Not a pure module */
